import { render, staticRenderFns } from "./ImgRender.vue?vue&type=template&id=3b62dc68"
import script from "./ImgRender.vue?vue&type=script&lang=js"
export * from "./ImgRender.vue?vue&type=script&lang=js"
import style0 from "./ImgRender.vue?vue&type=style&index=0&id=3b62dc68&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports